import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
// import { AuthService } from '../auth/services/auth.service';
// private auth: AuthService

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor() { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // const userDetails = this.auth.getUserInfo();
    // if (userDetails && userDetails.AccessToken) {
      const newRequest = request.clone({
        headers: request.headers.append(
          'authorization',
          `Bearer ya29.a0ARrdaM_xpK9DsKblykIKfqytI6c8WvD8JU85ncW5S7o_wBUg3_QSvNHgmG9-JRzpspWqSBPhwfmnyqzcvPtGGdUahvJoumQ9rsFCwXk_pupp4k0-yGle94RnJ4NqtMqiWQgY-86-cAy6aywIqPR0mZysowS4`
        )
      });
      return next.handle(newRequest);
    // } else {
    //   return next.handle(request);
    // }
  }
}
